import { learningClient } from '../api'
import {
  ActivityKind,
  ActivityStateRef,
  AttemptStatusRef,
} from '@sphere/learning/domain'
import { SubjectDto } from '@sphere/learning/domain'

export async function fetchActivityKinds(): Promise<ActivityKind[]> {
  const response = await learningClient.reference.activityKinds()
  return response.data
}

export async function fetchActivityStates(): Promise<{
  data: ActivityStateRef[]
  total: number
}> {
  const response = await learningClient.reference.activityStates()
  return {
    data: response.data || [],
    total: response.data?.length || 0,
  }
}

export async function fetchAttemptStatuses(): Promise<AttemptStatusRef[]> {
  const response = await learningClient.reference.attemptStatuses()
  return response.data
}
